export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14880.ee55f18d.jpg";